import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink } from 'react-router';
import { useAuth } from '../auth/AuthContext';
import { ContactDetails } from '../pages/public/shared';
import { SkipLink } from './a11y';
import { LanguagePicker } from './LanguagePicker';

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

/** Review fix F11: header/footer for the public pages, outside RequireAuth. */
export function PublicShell({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  return (
    <div className="public-shell">
      <SkipLink />
      <header className="public-header">
        <Link to="/" className="public-brand">
          <span className="logo-badge">
            <img src="/logo-face.png" alt="" className="logo-face" />
          </span>
          <span className="wordmark">Omnist</span>
        </Link>
        <nav className="public-nav" aria-label={t('public.nav.label')}>
          <NavLink to="/how-it-works" className={navClass}>{t('public.nav.howItWorks')}</NavLink>
          <NavLink to="/pricing" className={navClass}>{t('public.nav.pricing')}</NavLink>
          <NavLink to="/sample" className={navClass}>{t('public.nav.tryPractice')}</NavLink>
        </nav>
        <div className="public-header-actions">
          {isAuthenticated ? (
            <Link to="/home" className="btn btn-secondary btn-small">{t('public.nav.openApp')}</Link>
          ) : (
            <Link to="/login" className="btn btn-secondary btn-small">{t('public.nav.signIn')}</Link>
          )}
        </div>
      </header>

      <main id="main-content" className="public-main" tabIndex={-1}>
        {children}
      </main>

      <footer className="public-footer">
        <div className="public-footer-inner">
          <div className="public-footer-about">
            <span className="wordmark public-footer-brand">Omnist</span>
            <p className="public-footer-note">{t('public.footer.tagline')}</p>
            <ContactDetails compact />
          </div>
          <nav aria-label={t('public.footer.label')}>
            <ul className="public-footer-links">
              <li><Link to="/how-it-works">{t('public.nav.howItWorks')}</Link></li>
              <li><Link to="/pricing">{t('public.nav.pricing')}</Link></li>
              <li><Link to="/editorial-standards">{t('public.footer.editorial')}</Link></li>
              <li><Link to="/privacy">{t('public.footer.privacy')}</Link></li>
              <li><Link to="/terms">{t('public.footer.terms')}</Link></li>
              <li><Link to="/support">{t('public.footer.support')}</Link></li>
            </ul>
          </nav>
          {!isAuthenticated && <LanguagePicker id="footer-language" />}
        </div>
      </footer>
    </div>
  );
}
